import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { bulkDelete, endBulkDelete } from '../../store/actions/people';
import BulkDeleteModal from 'components/modals/bulk_delete_modal';

export class PeopleBulkDeleteModal extends React.Component {
  static propTypes = {
    bulkDelete: PropTypes.bool.isRequired,
    selectedPersonIds: PropTypes.array.isRequired,
    onBulkDelete: PropTypes.func.isRequired,
    onCancelBulkDelete: PropTypes.func.isRequired
  };

  handleBulkDelete = () => {
    const { onBulkDelete } = this.props;

    onBulkDelete();
  };

  render() {
    const { bulkDelete, selectedPersonIds, onCancelBulkDelete } = this.props;

    return (
      <BulkDeleteModal
        entityCount={(selectedPersonIds || []).length}
        entityName="Contacts"
        shown={bulkDelete}
        onCancel={onCancelBulkDelete}
        onDelete={this.handleBulkDelete}
      />
    );
  }
}

const mapStateToProps = state => ({
  bulkDelete: state.people.startBulkDelete,
  selectedPersonIds: state.selectList.selectedPersonIds
});

const mapDispatchToProps = {
  onBulkDelete: bulkDelete,
  onCancelBulkDelete: endBulkDelete
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleBulkDeleteModal);